export default __webpack_public_path__ + "static/media/play-circle.9d66d46a.svg";